// extracted by mini-css-extract-plugin
export default {"Title":"ThingsToDoConfiguration_Title__jtNWs","Row":"ThingsToDoConfiguration_Row__Y+d7S"};